// Nature-inspired color palette - warm beige, earth tones, forest greens
export const theme = {
    colors: {
        // Primary palette - warm earth tones
        primary: '#8B7355',       // Warm brown
        primaryLight: '#A89076',  // Light brown
        primaryDark: '#6B5344',   // Dark brown

        // Secondary - forest greens
        secondary: '#5D7A5D',     // Forest green
        secondaryLight: '#7A9A7A', // Sage green
        secondaryDark: '#4A614A',  // Deep forest

        // Accent - warm sunset
        accent: '#C4956A',        // Warm terracotta
        accentLight: '#D4A87A',   // Light terracotta
        accentDark: '#A47850',    // Deep terracotta

        // Backgrounds
        bgPrimary: '#F5F0E8',     // Warm cream
        bgSecondary: '#EDE6DB',   // Light beige
        bgTertiary: '#E5DDD0',    // Soft sand
        bgDark: '#3D3530',        // Dark wood

        // Text
        textPrimary: '#3D3530',   // Dark brown
        textSecondary: '#6B5F55', // Medium brown
        textMuted: '#9A8F85',     // Muted brown
        textLight: '#F5F0E8',     // Cream

        // Status colors
        success: '#6B8E6B',       // Moss green
        warning: '#C4956A',       // Terracotta
        error: '#A65D5D',         // Dusty rose
        info: '#7A8B8B',          // Slate

        // Difficulty
        easy: '#7A9A7A',          // Sage
        medium: '#C4956A',        // Terracotta
        hard: '#A65D5D',          // Dusty rose
        expert: '#6B5344',        // Dark brown

        // UI elements
        cardBg: '#FFFFFF',
        cardBorder: '#E5DDD0',
        overlay: 'rgba(61, 53, 48, 0.85)',
        shadow: 'rgba(61, 53, 48, 0.15)',
    },

    gradients: {
        primary: 'linear-gradient(135deg, #8B7355 0%, #5D7A5D 100%)',
        warm: 'linear-gradient(135deg, #C4956A 0%, #8B7355 100%)',
        nature: 'linear-gradient(180deg, #F5F0E8 0%, #EDE6DB 50%, #E5DDD0 100%)',
        forest: 'linear-gradient(135deg, #5D7A5D 0%, #4A614A 100%)',
        sunset: 'linear-gradient(135deg, #D4A87A 0%, #C4956A 50%, #A47850 100%)',
        card: 'linear-gradient(180deg, #FFFFFF 0%, #F5F0E8 100%)',
        canvas: 'linear-gradient(180deg, #E5DDD0 0%, #D4CCC0 100%)',
    },

    fonts: {
        primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
        display: "'Playfair Display', Georgia, serif",
    },

    spacing: {
        xs: '4px',
        sm: '8px',
        md: '16px',
        lg: '24px',
        xl: '32px',
        xxl: '48px',
    },

    borderRadius: {
        sm: '8px',
        md: '12px',
        lg: '16px',
        xl: '24px',
        full: '9999px',
    },

    shadows: {
        sm: '0 2px 8px rgba(61, 53, 48, 0.1)',
        md: '0 4px 16px rgba(61, 53, 48, 0.12)',
        lg: '0 8px 32px rgba(61, 53, 48, 0.15)',
        xl: '0 16px 48px rgba(61, 53, 48, 0.2)',
    },

    breakpoints: {
        xs: '320px',
        sm: '480px',
        md: '768px',
        lg: '1024px',
        xl: '1280px',
    },
};

export type Theme = typeof theme;
